<template>
  <div style="height: min-content">
    <v-layout row wrap justify-start my-1 style="overflow-y: auto">
      <div
        v-for="approachRule in getApproachRules(item)"
        :key="approachRule.id"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip
              small
              :color="getColorApproachRule(approachRule.type)"
              text-color="white"
              v-on="on"
              style="max-width: min-content"
            >
              <b>{{ approachRule.offset }}</b>
            </v-chip>
          </template>
          <div style="max-width: 350px">
            <p>{{ approachRule.type }}: {{ approachRule.time }}</p>
            <p>{{ approachRule.stimulus.text }}</p>
            <p>{{ approachRule.stimulus.subject }}</p>
            <p>{{ approachRule.stimulus.body }}</p>
            <p v-if="approachRule.initiatives">
              {{ approachRule.initiatives.message }}
            </p>
          </div>
        </v-tooltip>
      </div>

      <MessageInconsistencyAlert
        :inconsistencies="getApproachRulesInconsistencies(item)"
        :small="false"
      />
    </v-layout>
  </div>
</template>

<!-- align-content-start -->
<script>
import MessageInconsistencyAlert from "@/components/ui/MessageInconsistencyAlert.vue";

export default {
  name: "approach-rule-chips",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    MessageInconsistencyAlert,
  },
  methods: {
    getApproachRules(item) {
      return item.approach_flow.approach_rules.slice().sort((a, b) => {
        if (a.offset < b.offset) return -1;
        if (a.offset > b.offset) return 1;
        return 0;
      });
    },
    getApproachRulesInconsistencies(item) {
      if (
        !item ||
        !item.approach_flow ||
        !item.approach_flow.approach_rules ||
        !item.approach_flow.approach_rules.length
      )
        return [];

      const uniqueSet = new Set([]);

      item.approach_flow.approach_rules
        .map((rule) => rule.initiatives || [])
        .forEach((initiative) => {
          if (
            initiative.message_inconsistencies &&
            initiative.message_inconsistencies.length
          )
            initiative.message_inconsistencies.forEach((inconsistency) =>
              uniqueSet.add(inconsistency),
            );
        });
      return Array.from(uniqueSet);
    },
    getColorApproachRule(type) {
      switch (type) {
        case "SMS":
          return "indigo";
        case "PUSH":
          return "teal";
        case "EMAIL":
          return "orange";
        case "CALL_CELLPHONE":
          return "#007327";
        case "CALL_PHONE":
          return "#004D40";
        case "WHATSAPP":
          return "#535a11";
        default:
          return "primary";
      }
    },
  },
};
</script>
